<section>
  <div class="scroll-container" #scrollContainer (scroll)="onScroll($event)">
      <div nz-row>
          <div nz-col nzSpan="20">
              <div class="heading-fs-18 mb-0">Published Media</div>
          </div>
          <div nz-col nzSpan="4" class="text-right pt-2">
              <span nz-icon nzType="close" nzTheme="outline" class="cursor-pointer" (click)="cancel()"></span>
          </div>
          <div nz-col nzSpan="24">
              <nz-divider></nz-divider>
          </div>
      </div>
      <div nz-row>
          <div nz-col nzSpan="24">
              <form nz-form>
                            <div class="row align-items-center search-row">
                                <div class="search-input">
                                    <nz-form-item class="mb-0">
                                        <nz-form-control class="mb-0 drawer-search-input">
                                            <nz-input-group [nzPrefix]="prefixIcon" [nzSuffix]="suffixIcon">
                                                <input nz-input placeholder="Search Media" name="filterKey" [disabled]="!hasMediaList"
                                                    [(ngModel)]="filterModel.filterKey" (keydown.enter)="onSearch()"
                                                    (ngModelChange)="filterKeyChanged()" [maxlength]="100" [disabled]="!hasMediaList"
                                                    appAlphaNumericsLevelThree />
                                            </nz-input-group>
                                            <ng-template #suffixIcon>
                                                <span nz-icon nzType="close" nzTheme="outline" *ngIf="filterModel.filterKey"
                                                    (click)="clearSearch()" class="clear-search cursor-pointer"></span>
                                            </ng-template>
                                            <ng-template #prefixIcon>
                                                <span nz-icon nzType="search" nzTheme="outline" (click)="onSearch()"
                                                    class="cursor-pointer"></span>
                                            </ng-template>
                                        </nz-form-control>
                                    </nz-form-item>                              
                                </div>
                                <div>
                                    <button (click)="closeDrawer.emit({ isEdit: true })" nz-button nzType="primary" class="mr-3">Edit Design
                                     </button>
                                </div>
                            </div>
              </form>
          </div>
      </div>

      <form (ngSubmit)="submit()">
          <div nz-col nzSpan="24">
              <div nz-row class="mt-2">
                  <div nz-col nzSpan="24" class="mb-3">
                      <div class="d-flex justify-content-end cursor-pointer">
                          <nz-form-item class="sort-by-dropdown"
                              *ngIf="isModelLoaded && hasMediaList && model.length > 1">
                              <nz-form-control>
                                  <nz-select nzPlaceHolder="Sort By" [(ngModel)]="sortOrder" name="sortOrder"
                                      (ngModelChange)="sortMedia()">
                                      <nz-option [nzValue]="'ascending'" nzLabel="Ascending"></nz-option>
                                      <nz-option [nzValue]="'descending'" nzLabel="Descending"></nz-option>
                                  </nz-select>
                              </nz-form-control>
                          </nz-form-item>
                      </div>
                  </div>
              </div>
          </div>
          <nz-spin [nzSpinning]="isLoading" class="mobOne-action-m-b">
              <div nz-row *ngFor="let item of model" [nzGutter]="[16,16]" class="list-item mb-2 pt-1 cursor-pointer">
                  <div nz-col nzXs="11" nzSm="15" nzMd="15" nzLg="15" nzXl="15">
                      <div class="d-flex align-items-center cursor-pointer">
                          <div class="list-img-wrapper mr-3">
                              <img [src]="item.iconUrl" alt="">
                          </div>
                          <div class="text-ellipsis"><a class="text-ul text-ellipsis "
                            (click)="editMedia(item.mediaAppType, item.id, item.id)">{{item.title}}</a><br />
                              <div class="fs-12 text-primary" *ngIf="newMediaIds.includes(item.id)">New</div>
                          </div>
                      </div>
                  </div>
                  <div nz-col nzXs="6" nzSm="4" nzMd="4" nzLg="4" nzXl="4">
                      <div nz-row class="align-items-center mt-2">
                        
                          <span class="text-ellipsis">{{item.mediaAppTitle}}</span>
                      </div>
                  </div>
                  <div nz-col nzSpan="7" nzSm="6" nzMd="5" nzLg="5" nzXl="5">
                      <div nz-col nzSpan="6" class="align-items-center"
                          *ngIf="item.videoEncodingStatus && item.videoEncodingStatus !==3">
                          <span nz-icon [nzType]="'loading'" class="icon-primary" nz-tooltip
                              nzTooltipTitle="Video optimization in progress. We'll notify you when it's complete."></span>
                          &nbsp;<span class="text-nowrap">Optimizing</span>
                      </div>
                      <div nz-col nzSpan="6" class="align-items-center"
                          *ngIf="!item.videoEncodingStatus || item.videoEncodingStatus === 3">

                          <span nz-icon nzType="check-circle" nzTheme="fill"
                              *ngIf="item.status === 1 && !item.isScheduled" class="status-icon-success mr-2"></span>
                          <span *ngIf="item.status === 1 && !item.isScheduled">Active</span>

                          <span nz-icon nzType="close-circle" nzTheme="fill" *ngIf="item.status === 2"
                              class="status-icon-danger mr-2"></span>
                          <span *ngIf="item.status === 2" class="text-nowrap">In-active</span>

                          <span nz-icon nzType="check-circle" nzTheme="fill"
                              *ngIf="item.status === 1 && item.isScheduled" class="status-icon-primary mr-2"></span>
                          <span *ngIf="item.status === 1 && item.isScheduled">Scheduled</span>

                          <span nz-icon nzType="clock-circle" nzTheme="fill" *ngIf="item.status === 4"
                              class="status-icon-primary mr-2"></span>
                          <span *ngIf="item.status === 4">Scheduled</span>
                      </div>
                  </div>

                  <nz-divider  class="mt-1 mb-0"></nz-divider>
              </div>
              <div *ngIf="isModelLoaded && model && model.length == 0 && hasMediaList" class="empty-list-container">
                  <span class="text-muted fs-14">No media match your search.</span>
              </div>
              <div *ngIf="isModelLoaded && !hasMediaList && model.length == 0" class="empty-list-container">
                  <span class="text-muted fs-14">You haven’t published any media from this design yet. “Publish to Media” from Designer to make it available for use in Playlists and Broadcasts.</span>
              </div>
          </nz-spin>
      </form>

      
  </div>
</section>